
import CatalogGridCard from "../../../common/catalog/CatalogGridCard";
import WebinarCardStartMeta from "../../WebinarCardStartMeta";

export default function Webinar({ webinar }) {
	return (
		<CatalogGridCard
			to={`/webinar_detail/${webinar.id}/`}
			title={webinar.title}
			imageUrl={webinar.image_url}
			product={webinar}
			showFreeBadge
			actionLabel="مشاهده وبینار"
			metaSlot={<WebinarCardStartMeta webinar={webinar} />}
		/>
	);
}
